export function toLightweightPapiUserForMentionExtension(user) {
    return {
        icon: user.usericon,
        username: user.username,
        userId: user.userId,
        type: user.type
    };
}

//# sourceMappingURL=toLightweightPapiUserForMentionExtension.js.map